import styled from "styled-components/macro";

interface HeaderProp {
  titleColor: string;
}
interface TextProp {
  textColor: string;
}

export const ViewHeader = styled.h2<HeaderProp>`
  role: header;
  color: ${({ titleColor }) => titleColor};
  font-family: Fjalla One, sans-serif;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  font-size: 2rem;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const ViewHeader2 = styled.h3<HeaderProp>`
  color: ${({ titleColor }) => titleColor};
  font-family: Fjalla One, sans-serif;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  font-size: 1.5rem;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const ContactCardHeader1 = styled.h2<HeaderProp>`
  color: ${({ titleColor }) => titleColor};
  role: header;
  font-family: Roboto, sans-serif;
  text-align: left;
  font-weight: 900;
  margin: 0;
  font-size: 30px;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  @media (max-width: 427px) {
    font-size: 1rem;
  }
`;

export const ContactCardHeader2 = styled.h3`
  role: header;
  font-family: Roboto, sans-serif;
  text-align: left;
  font-weight: 400;
  margin: 0;
  font-size: 28px;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  @media (max-width: 427px) {
    font-size: 1rem;
  }
`;

export const ViewTitle = styled.h4`
  font-family: Fjalla One, sans-serif;
  text-align: center;
  font-size: 1.17rem;
`;

export const ContactCardLine = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 20px;
  text-align: left;
  line-height: 2.5;
  @media (max-width: 942px) {
    font-size: 0.8rem;
  }
  @media (max-width: 427px) {
    font-size: 0.6rem;
  }
`;

export const ViewText = styled.section<TextProp>`
  h1,
  h2 {
    color: ${({ textColor }) => textColor};
    font-family: Fjalla One, sans-serif;
    margin: 0;
    font-size: 2.5rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  h3 {
    color: ${({ textColor }) => textColor};
    font-family: Fjalla One, sans-serif;
    text-align: center;
    margin: 0;
    font-size: 2rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  h4 {
    color: ${({ textColor }) => textColor};
    font-family: Fjalla One, sans-serif;
    margin: 0;
    font-size: 1.5rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  h5,
  h6 {
    color: ${({ textColor }) => textColor};
    font-family: Fjalla One, sans-serif;
    text-align: center;
    margin: 0;
    font-size: 1.25rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  ul {
    color: ${({ textColor }) => textColor};
    padding: 1rem;
    list-style-type: disc;
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    overflow-wrap: break-word;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    @media screen and (max-width: 900px) {
      font-size: 0.7rem;
    }
  }
  ol {
    color: ${({ textColor }) => textColor};
    padding: 1rem;
    list-style-type: decimal;
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    overflow-wrap: break-word;
    @media screen and (max-width: 900px) {
      font-size: 0.7rem;
    }
  }

  p {
    color: ${({ textColor }) => textColor};
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    margin: 1rem 0;
    overflow-wrap: break-word;

    @media screen and (max-width: 900px) {
      font-size: 0.8rem;
    }
  }
  a {
    color: blue;
    text-decoration: underline;
  }
`;
export const ViewParagraph = styled.p<TextProp>`
  color: ${({ textColor }) => textColor};
  font-family: Roboto, sans-serif;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin: 1rem 0;
  overflow-wrap: break-word;
  text-align: left;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    font-size: 0.8rem;
  }
`;
